import { atom } from 'recoil';

export interface Role {
  id?: number;
  name?: string;
  code?: string;
  admin?: boolean;
  superAdmin?: boolean;
  dashboardAdmin?: boolean;
}

export interface RemoveDashboards {
  dashboards: string[];
  visualizationCode: any;
}

export interface InsertDashboards {
  dashboards: string[];
  visualizationCode: any;
}

export const rolesState = atom<Role[]>({
  key: 'roles',
  default: [],
});

// Current role
export const currentRoleState = atom({
  key: 'currentRole',
  default: {} as Role,
});

export const visualisationRolesState = atom<Role[]>({
  key: 'visualisationRoles',
  default: [],
});

export const visualisationDashboardsState = atom<any[]>({
  key: 'visualisationDashboards',
  default: [],
});

export const dashboardRolesState = atom<Role[]>({
  key: 'dashboardRoles',
  default: [],
});

export const deleteVisualisationDashboardsState = atom<RemoveDashboards>({
  key: 'deleteVisualisationDashboards',
  default: {} as RemoveDashboards,
});

export const insertVisualisationDashboardsState = atom<InsertDashboards>({
  key: 'insertVisualisationDashboards',
  default: {} as InsertDashboards,
});

export const initialVisualisationDashboardsState = atom<any[]>({
  key: 'initialVisualisationDashboards',
  default: [],
});
